import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import styled from 'styled-components';

export const StyledArticleMeta = styled.div`
  grid-column: 1 / -1;
`;

export const TopicTitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const StyledTitle = styled(Typography)``;

export const TopicIcon = styled(Icon)`
  display: none;
  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    display: block;
    flex-shrink: 0;
  }
`;

export const BodyContainer = styled(Typography)`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledDivider = styled.div`
  padding-right: 0.4rem;
`;

export const Readtime = styled.div`
  padding-right: 0.4rem;
`;

export const Date = styled.div`
  font-style: italic;
`;
